import React, { useState } from "react";

import useStyles from "@hooks/useStyles";

import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";

import LineBreak from "@components/Global/Custom/Icons/LineBreak";

const WebsitePDF = () => {
	const classes = useStyles("Website");

	const backgroundColor = ""; // #ffebe5
	const backgroundGradient = `linear-gradient(120deg,#79dfff 15%,#865cff)`; // for testing  linear-gradient(121.04deg,#79dfff 15.69%,#865cff)
	const backgroundImage = ``; // for testing https://wallpapercave.com/wp/wp8377155.jpg
	const coloredBox = false;

	const header = `PDF Menu`;
	const subHeader = `Get our menu updates, event schedule, holiday hours, and exclusive deals.`;
	const tagline = "";
	const textAlign = "center"; // left / center / right
	const lineBreak = false;
	const content = "";

	const button = "Download";
	const buttonLink = "/wesbite/about-us";

	const buttonSecondary = "Secondary button";
	const buttonSecondaryLink = "/wesbite/about-us";

	return (
		<React.Fragment>
			<section
				className={
					tagline || header || subHeader || lineBreak || content
						? "websiteComponent"
						: "websiteComponent thin"
				}
				style={{
					backgroundColor:
						!coloredBox && backgroundColor ? backgroundColor : "",
					backgroundImage:
						!coloredBox && backgroundGradient ? backgroundGradient : "unset",
				}}
			>
				{backgroundImage && (
					<Box
						position={"absolute"}
						top={0}
						bottom={0}
						width={"100%"}
						style={{
							backgroundImage: `url(${backgroundImage})`,
							backgroundRepeat: "no-repeat",
							backgroundSize: "cover",
							backgroundPosition: "50% 50%",
							opacity: "0.4",
							//filter: "blur(2px)",
						}}
						zIndex={1}
					/>
				)}

				<Container maxWidth={"lg"} disableGutters style={{ zIndex: 3 }}>
					<div
						className={coloredBox ? classes.featuredTextBox : undefined}
						style={{
							backgroundColor:
								coloredBox && backgroundColor ? backgroundColor : "unset",
							backgroundImage:
								coloredBox && backgroundGradient ? backgroundGradient : "unset",
						}}
					>
						<Grid
							container
							spacing={8}
							justifyContent="center"
							alignItems={textAlign}
						>
							{(tagline ||
								header ||
								subHeader ||
								lineBreak ||
								content ||
								button ||
								buttonSecondary) && (
								<Grid item xs={12}>
									<Box
										display={"flex"}
										flexDirection={"column"}
										justifyContent={"center"}
										alignItems={textAlign}
										height={"100%"}
									>
										{tagline && (
											<Box className="tagline" textAlign={textAlign}>
												{tagline}
											</Box>
										)}

										{header && (
											<Box component={"h2"} textAlign={textAlign}>
												{header}
											</Box>
										)}

										{subHeader && (
											<Box component={"h3"} textAlign={textAlign}>
												{subHeader}
											</Box>
										)}

										{lineBreak && (
											<Box my={1} textAlign={textAlign}>
												<LineBreak className={classes.lineBreak} />
											</Box>
										)}

										{content && (
											<>
												<Box component={"p"} textAlign={textAlign}>
													{content}
												</Box>
											</>
										)}

										{(button || buttonSecondary) && (
											<Box
												className={classes.columnButtonsBox}
												textAlign={textAlign}
												justifyContent={textAlign}
											>
												{button && (
													<Button
														size="large"
														color="primary"
														variant="contained"
														disableElevation
														href={buttonLink}
														className="columnButton"
													>
														{button}
													</Button>
												)}

												{buttonSecondary && (
													<Button
														size="large"
														color="secondary"
														variant="outlined"
														disableElevation
														href={buttonSecondaryLink}
														className="columnButton"
													>
														{buttonSecondary}
													</Button>
												)}
											</Box>
										)}
									</Box>
								</Grid>
							)}

							<Grid item xs={12}>
								<Box
									display={{ xs: "none", sm: "block" }}
									mt={6}
									height={650}
									maxWidth={"100%"}
									overflow={"hidden"}
									position={"relative"}
									borderRadius={20}
								>
									<Box
										component={"embed"}
										overflow={"auto"}
										width={"100%"}
										height={"100%"}
										className="pdfobject"
										src="https://my-business-107689-109998.square.site/uploads/b/aba893c0-bba5-11ee-ae2a-ad24ad59e968/a4622080-0e0e-11ef-936a-fbc960770662.pdf"
										type="application/pdf"
									/>
								</Box>
							</Grid>
						</Grid>
					</div>
				</Container>
			</section>
		</React.Fragment>
	);
};

export default WebsitePDF;
